<template>
  <HeaderBar />
  <ProjectList />
  <router-view></router-view> <!--KeysPanel when navigating to /projects/:prjnum-->
  <div v-show="showAlert" id="alert-wrapper"> <!---v-if unmounts AlertBox-->
        <AlertBox :alertMsg="alertMsg" :successful="true" /> <!---for success messages that disappear-->
  </div>
</template>
  
<script>
  
  import HeaderBar from './components/HeaderBar.vue';
  import ProjectList from './components/ProjectList.vue';
  import AlertBox from "./components/AlertBox.vue";
  

  export default {
    name: 'ProjectPage',
    components: {
      HeaderBar,
      ProjectList,
      AlertBox
    },
    data() {
      return {
        showAlert: false,
        alertMsg: '',
      }
    },
    methods: {
      addAlert(msg) {
        this.alertMsg = msg;
        this.showAlert = true;
      }
    },
    mounted() {
      this.emitter.on('active-key-deleted', () => this.addAlert("Key deleted successfully"));
      this.emitter.on('expired-key-deleted', () => this.addAlert("Key deleted successfully"));
      this.emitter.on('key-copied', () => this.addAlert("Key copied!"));
    },
    beforeUnmount() {
      this.emitter.off('active-key-deleted', () => this.addAlert("Key deleted successfully"));
      this.emitter.off('expired-key-deleted', () => this.addAlert("Key deleted successfully"));
      this.emitter.off('key-copied', () => this.addAlert("Key copied!"));
    },
    watch: {
      showAlert(newVal) {
        if (newVal) {
          setTimeout(() => { this.showAlert = false; this.alertMsg = '';}, 3000);
        }
      }
    }
  }

</script>

<style scoped>

#alert-wrapper {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

</style>

